import { render, staticRenderFns } from "./AssignV1.vue?vue&type=template&id=b8cc2120&scoped=true&"
import script from "./AssignV1.vue?vue&type=script&lang=js&"
export * from "./AssignV1.vue?vue&type=script&lang=js&"
import style0 from "./AssignV1.vue?vue&type=style&index=0&id=b8cc2120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cc2120",
  null
  
)

export default component.exports